import { RootState } from "app/store";
import { TrialProduct, InitializeState } from "./types";

export const selectTrialList = (state: RootState): TrialProduct[] => {
  const products = state.trial.domains.Products;

  if (!products) {
    return [];
  }
  return products;
};

export const selectInitializeState = (state: RootState): InitializeState =>
  state.trial.apps.initialize;
